import { EnumProducts } from "services/caju/enums/enumProducts";
import { EnumLabelTag } from "services/tagManager/enums/enumLabelTag";

export const listProducts = [
  {
    id: EnumProducts.MULTIBENEFITS,
    labelTag: EnumLabelTag.TAG_MULTIBENEFITS,
    title: "Benefícios",
    description:
      "Cartão de benefícios, múltiplas categorias e plataforma unificada de gestão",
  },
  {
    id: EnumProducts.CORP_EXPENSES,
    labelTag: EnumLabelTag.TAG_CORPEXPENSES,
    title: "Despesas Corporativas",
    description: "Gestão de despesas corporativas, adiantamentos e reembolsos.",
  },
  {
    id: EnumProducts.AWARDS,
    labelTag: EnumLabelTag.TAG_AWARDS,
    title: "Premiação",
    description:
      "Saldo de uso livre para premiar o time e celebrar datas especiais.",
  },
  {
    id: EnumProducts.CAJU_CICLOS,
    labelTag: EnumLabelTag.TAG_CAJUCICLOS,
    title: "Gestão de Pessoas",
    description:
      "A plataforma ideal para empresas que querem uma gestão de RH mais eficiente e segura.",
  },
  {
    id: EnumProducts.CAJU_MAIS,
    labelTag: EnumLabelTag.TAG_CAJUMAIS,
    title: "Saúde e Bem-estar",
    description:
      "Cuide do seu time com parceiros que fazem a diferença: Wellhub, Conexa, Optum e mais.",
  },
];
